module.exports = __webpack_public_path__ + "img/logologin.d78e2477.png";